import VasOptionList from "./vas-option-list.page";

export default VasOptionList;
